import React, { useEffect, useState } from 'react'

import useLandingContext from '../hooks/useLandingContext'
import FunnelLayout from '../components/layout/FunnelLayout'
import Routing from '../components/landing/Routing'
import LoadingSpinner from '../components/landing/LoadingSpinner'

export default ({ pageContext, location }) => {
  const landingContext = useLandingContext(location, pageContext)
  const dataLoaded = process.env.BUILD_STAGE !== 'build-html' && !landingContext.offerIsFetching && !landingContext.vinIsFetching && !(landingContext.offer && landingContext.offer.prospect && !landingContext.model)
  const [loaded, setLoaded] = useState(dataLoaded)
  useEffect(() => {
    if (dataLoaded) setLoaded(true)
  }, [dataLoaded])
  return !landingContext.initMode ? (
    <FunnelLayout location={location} {...landingContext} isBuildStep={process.env.BUILD_STAGE === 'build-html'}>
      {!loaded ? <LoadingSpinner {...landingContext} /> : <Routing {...landingContext} {...{ location }} />}
    </FunnelLayout>
  ) : (
    <LoadingSpinner {...landingContext} />
  )
}
